import { Observable } from "rxjs";
import _ from "lodash";

import st from "lib/utils/index";
import { ProductScheduleSlotsRepository } from "lib/repositories/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "calendar/CalendarView/INITIALIZE_VIEW";
export const LOAD_SLOTS = "calendar/CalendarView/LOAD_SLOTS";
export const FETCH_SLOTS = "calendar/CalendarView/FETCH_SLOTS";
export const FETCH_SLOTS_START = "calendar/CalendarView/FETCH_SLOTS_START";
export const FETCH_SLOTS_SUCCESS = "calendar/CalendarView/FETCH_SLOTS_SUCCESS";
export const FETCH_SLOTS_FAILURE = "calendar/CalendarView/FETCH_SLOTS_FAILURE";
export const SET_FILTERS = "calendar/CalendarView/SET_FILTERS";
export const FRONTEND_FILTERS_CHANGED = "calendar/CalendarView/FRONTEND_FILTERS_CHANGED";
export const BACKEND_FILTERS_CHANGED = "calendar/CalendarView/BACKEND_FILTERS_CHANGED";
export const FRONTEND_REFILTER = "calendar/CalendarView/FRONTEND_REFILTER";

export const stateSelector = (state) => state.calendar.CalendarView;

const slotsResource = createResourceInstance({
  LOAD: LOAD_SLOTS,
  FETCH: FETCH_SLOTS,
  FETCH_START: FETCH_SLOTS_START,
  FETCH_SUCCESS: FETCH_SLOTS_SUCCESS,
  FETCH_FAILURE: FETCH_SLOTS_FAILURE,
  stateSelector,
  stateKey: "slots",
  getModel: (state) => {
    return ProductScheduleSlotsRepository.findAll({
      company_id: state.filters.supplier_id || undefined,
      starts_at_gte: state.filters.starts_at_gte || undefined,
      starts_at_lte: state.filters.starts_at_lte || undefined,
      hide_cutofftime: !st.authorize.company.supplier,
    });
  },
});

const FRONTEND_FILTER_PROPS = ["scope", "product_id", "show_inactive_offers"];
const BACKEND_FILTER_PROPS = ["supplier_id", "starts_at_gte", "starts_at_lte"];

const initialState = {
  slots: slotsResource.initialState,
  filteredSlots: [],
  filters: {
    scope: "all",
    supplier_id: null,
    product_id: null,
    starts_at_gte: null,
    starts_at_lte: null,
    hide_cutofftime: true,
    show_inactive_offers: false,
  },
};

const reducers = {
  ...slotsResource.reducersMap,

  [INITIALIZE_VIEW]: (state, { filters }) => ({
    ...initialState,
    filters,
  }),

  [SET_FILTERS]: (state, { filters }) => ({
    ...state,
    filters,
  }),

  [FRONTEND_REFILTER]: (state) => {
    const {
      filters,
      slots: { model: slots },
    } = state;
    const filteredSlots = (slots || [])
      .filter((sl) => {
        if (filters.scope === "all") {
          return sl.available || sl.awaiting_for_customer || sl.awaiting_for_company || sl.booked;
        } else if (filters.scope === "available") {
          return sl.available;
        } else if (filters.scope === "awaiting") {
          return sl.awaiting_for_customer || sl.awaiting_for_company;
        } else if (filters.scope === "booked") {
          return sl.booked;
        } else {
          throw new Error(`Unknown filters.scope value: ${filters.scope}`);
        }
      })
      .filter((sl) => !filters.product_id || sl.product_id === (filters.product_id === -1 ? null : filters.product_id))
      .filter((sl) => filters.show_inactive_offers || sl.product_status == null || sl.product_status === "published");
    return {
      ...state,
      filteredSlots,
    };
  },
};

const epics = [
  ...slotsResource.epics,

  (actions$) =>
    actions$
      .ofType(INITIALIZE_VIEW)
      .merge(actions$.ofType(BACKEND_FILTERS_CHANGED).debounceTime(300))
      .mapTo(fetchSlots()),

  (actions$) =>
    actions$
      .ofType(FETCH_SLOTS_SUCCESS)
      .merge(actions$.ofType(LOAD_SLOTS))
      .merge(actions$.ofType(FRONTEND_FILTERS_CHANGED).debounceTime(150))
      .mapTo({ type: FRONTEND_REFILTER }),

  (actions$) =>
    Observable.of(initialState.filters)
      .merge(actions$.ofType(SET_FILTERS).map(({ filters }) => filters))
      .pairwise()
      .flatMap(([a, b]) => {
        const haveBackendFiltersChanged = !_.isEqual(
          _.pick(a, ...BACKEND_FILTER_PROPS),
          _.pick(b, ...BACKEND_FILTER_PROPS)
        );
        const haveFrontendFiltersChanged = !_.isEqual(
          _.pick(a, ...FRONTEND_FILTER_PROPS),
          _.pick(b, ...FRONTEND_FILTER_PROPS)
        );
        return Observable.concat(
          haveBackendFiltersChanged ? Observable.of({ type: BACKEND_FILTERS_CHANGED }) : Observable.empty(),
          haveFrontendFiltersChanged ? Observable.of({ type: FRONTEND_FILTERS_CHANGED }) : Observable.empty()
        );
      }),
];

export const { load: loadSlots, fetch: fetchSlots } = slotsResource.actions;

export function initializeView({ filters }) {
  return { type: INITIALIZE_VIEW, filters };
}

export function setFilters(filters) {
  return { type: SET_FILTERS, filters };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/calendar/CalendarView/index.js